import { useSelector } from 'react-redux';

export const useWalletConnection = () => {
  // Get wallet info from Redux state
  const account = useSelector((state) => state.auth.account);
  const wallet = useSelector((state) => state.auth.wallet);
  const isConnected = useSelector((state) => state.auth.isConnected);

  // Helper flags
  const isMetaMask = wallet === 'metamask';
  const isRabby = wallet === 'rabby';
  const isCoinbase = wallet === 'coinbase';
  const isTrust = wallet === 'trust';
  const isOkx = wallet === 'okx';
  const isKeplr = wallet === 'keplr';
  const isBybit = wallet === 'bybitWallet';
  const isThirdweb = wallet === 'thirdweb';
  const isWeb3Auth = wallet === 'web3auth';
  const isCosmos = isKeplr;
  const isEvm = isMetaMask || isRabby || isCoinbase || isTrust || isOkx || isBybit || isThirdweb || isWeb3Auth;

  // Return normalized walletType (for compatibility with existing code)
  const walletType = wallet;

  return {
    account,
    wallet,
    walletType, // For backward compatibility with your existing code
    isConnected: isConnected && !!account && !!wallet,
    isMetaMask,
    isRabby,
    isCoinbase,
    isTrust,
    isOkx,
    isKeplr,
    isBybit,
    isThirdweb,
    isWeb3Auth,
    isCosmos,
    isEvm,
    // Helper methods
    getWalletDisplayName: () => {
      switch (wallet) {
        case 'metamask': return 'MetaMask';
        case 'rabby': return 'Rabby';
        case 'coinbase': return 'Coinbase Wallet';
        case 'trust': return 'Trust Wallet';
        case 'okx': return 'OKX Wallet';
        case 'keplr': return 'Keplr Wallet';
        case 'bybitWallet': return 'Bybit Wallet';
        case 'thirdweb': return 'Thirdweb';
        case 'web3auth': return 'Web3Auth';
        default: return 'Unknown Wallet';
      }
    },
    // Method to check if current wallet supports multi-VM
    supportsMultiVm: () => {
      return wallet === 'metamask' || wallet === 'keplr';
    }
  };
};
